export default __webpack_public_path__ + "static/media/aquarius.db19845b.png";